import { Platform } from 'quasar'

// Bloquea el acceso a un modulo solo-web cuando se navega desde Capacitor.
// Power BI es solo web por el momento la app movil no tendra soporte para reportes.
// Se puede usar este guard para otros modulos que sean solo-web.
export function webOnlyGuard () {
  if (Platform.is.capacitor) return { name: 'navigation.home' }
  return true
}
